const CONSTANTS = {
  DEFAULT_CLAIMS_PER_PAGE: 20,
  DA_REQUESTS_PER_PAGE: 10,
  POSTGRES_INT4_MAX: 2147483647,
} as const;

export default CONSTANTS;
